import { useGetAllMySuppliers } from '@/api/supplier.api';
import ViewVehicleWithChauffeurForm from '@/components/vehicleWithChauffeur/ViewVehicleWithChauffeurForm';
import { useResourceLanguage } from '@/hooks/useResourceLanguage';
import { useGetVehicleWithChauffeur } from '@/hooks/useVehicleWithChauffeur';
import { Loader } from 'lucide-react';
import { memo } from 'react';
import { useParams } from 'react-router';

const ViewVehicleWithChauffeurFormMemo = memo(ViewVehicleWithChauffeurForm);

const ViewVehicleWithChauffeurPage = () => {
  const { benefitId = '' } = useParams();

  const { language, setLanguage } = useResourceLanguage();

  const {
    data: vehicleWithChauffeur,
    isLoading,
    isSuccess,
  } = useGetVehicleWithChauffeur(benefitId);
  const { data: suppliers } = useGetAllMySuppliers();

  return isLoading ? (
    <Loader />
  ) : (
    isSuccess && (
      <ViewVehicleWithChauffeurFormMemo
        vehicleWithChauffeur={vehicleWithChauffeur}
        suppliers={suppliers}
        language={language}
        setLanguage={setLanguage}
        key={`vehicle-with-chauffeur-${vehicleWithChauffeur.id}`}
      />
    )
  );
};

export default ViewVehicleWithChauffeurPage;
